module.exports = __webpack_public_path__ + "static/media/port_log2.3963ac43.jpg";